import { idempotencyConfig } from "./idempotency";
export const addMemberToClub = async (client, data) => {
    const response = await client.post("/members/add-to-club", data);
    return response.data;
};
export const getMemberIdentityPreview = async (client, clubId, params) => {
    const response = await client.get(`/clubs/${clubId}/member-identity-preview`, { params });
    return response.data;
};
export const validateMembership = async (client, userId) => {
    const response = await client.get(`/members/validate/${userId}`);
    return response.data;
};
export const getUserByClub = async (client, clubId, userId) => {
    const response = await client.get(`/members/by-club/${clubId}/${userId}`);
    return response.data;
};
export const getClubUser = async (client, userId) => {
    const response = await client.get(`/members/by-club/${userId}`);
    return response.data;
};
export const getMemberMembershipHistory = async (client, clubId, userId, params) => {
    const response = await client.get(`/members/by-club/${clubId}/${userId}/memberships`, { params });
    return response.data;
};
export const getMemberBillingHistory = async (client, clubId, userId, params) => {
    const response = await client.get(`/members/by-club/${clubId}/${userId}/billing`, { params });
    return response.data;
};
export const getMemberAttendanceHistory = async (client, clubId, userId, params) => {
    const response = await client.get(`/members/by-club/${clubId}/${userId}/attendance`, { params });
    return response.data;
};
export const revokeMembership = async (client, data, options) => {
    const config = idempotencyConfig(options);
    const response = config
        ? await client.post("/memberships/revoke", data, config)
        : await client.post("/memberships/revoke", data);
    return response.data;
};
export const renewMembership = async (client, userId, clubId, body, options) => {
    const url = clubId
        ? `/memberships/renew/${userId}/${clubId}`
        : `/memberships/renew/${userId}`;
    const config = idempotencyConfig(options);
    const response = config
        ? await client.post(url, body ?? {}, config)
        : await client.post(url, body ?? {});
    return response.data;
};
export const assignMembership = async (client, params, options) => {
    const config = idempotencyConfig(options);
    const response = config
        ? await client.post("/memberships/assign", params, config)
        : await client.post("/memberships/assign", params);
    return response.data;
};
export const changePlan = async (client, params, options) => {
    const config = idempotencyConfig(options);
    const response = config
        ? await client.post("/memberships/change-plan", params, config)
        : await client.post("/memberships/change-plan", params);
    return response.data;
};
export const updateMembership = async (client, subscriptionId, params) => {
    const response = await client.put(`/memberships/${subscriptionId}`, params);
    return response.data;
};
export const correctMembershipValidity = async (client, subscriptionId, params) => {
    const response = await client.patch(`/memberships/${subscriptionId}/validity`, params);
    return response.data;
};
export const recordAttendance = async (client, params) => {
    const response = await client.post("/members/record-attendance", params);
    return response.data;
};
